"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetMissingAgreements = void 0;
const Base_1 = require("./Base");
exports.GetMissingAgreements = {
    url: Base_1.URL_BASE + "/GetMissingAgreements",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetMissingAgreements.js.map